import { createNamespacedHelpers } from 'vuex';
import ChannelAction from '@/components/channel_action/ChannelAction.vue';

const { mapState: mapChannelState } = createNamespacedHelpers('Channel');
const { mapState: mapUserState } = createNamespacedHelpers('User');
const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'MessageHeader',
  components: {
    ChannelAction
  },
  data: function() {
    return {
      pickLabel: ''
    };
  },
  computed: {
    ...mapUserState({
      isPremium: state => state.isCurrentUserPremium
    }),
    ...mapChannelState({
      currentChannel: state => state.currentChannel,
      getChannelStatus: function(state) {
        return state.currentChannel.status;
      },

      isOwned: function(state) {
        const { status, agentId } = state.currentChannel;
        return status === 'active' && agentId === this.currentConcierge.agentId;
      },

      isActive: function(state) {
        const { status } = state.currentChannel;
        return status === 'active';
      },

      isWaiting: function(state) {
        const { status } = state.currentChannel;
        return status === 'waiting';
      },

      isArchived: function(state) {
        const { status } = state.currentChannel;
        return status === 'archived';
      }
    }),

    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge,

      isAllowedAccess: function(state) {
        return state.currentConcierge.conciergeLevel >= 199;
      }
    }),

    ...mapUserState({
      currentUser: state => state.currentUser,

      getFullName: function(state) {
        const { firstName, lastName } = state.currentUser || {};
        return `${firstName || ''} ${lastName || ''}`;
      }
    })
  },
  watch: {
    currentChannel: {
      immediate: true,
      handler(newVal) {
        let label = 'Picked by ';

        if (this.currentConcierge.agentId === newVal.agentId) {
          this.pickLabel = label + ' You';
        } else {
          this.pickLabel = label + newVal.agentId;
        }
      },
      deep: true
    }
  },
  methods: {
    setCurrentTab: function(payload) {
      this.$emit('update:currentTab', payload.tab);
    }
  }
};
